import { Component, OnInit, Input, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService, PartnerOrderService, AppDataService } from 'app/services';
import { LokalOrderStatusEnum } from 'app/models';
import { Utils } from 'app/utils';
import moment from 'moment';
import { CustomWindow } from 'app/@types';
import { MatDialog } from '@angular/material/dialog';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { PartnerOrderViewComponent } from 'app/partner/partner-orders/partner-order-view/partner-order-view.component';
import { OrderDeliveryWayEnum } from 'app/models/enums/lokal/order-delivery-way.enum';
import { ComboItemDto } from 'app/merchant/partners-portal/interfaces/combo-item.interface';
import { DisputeReasonEnum } from 'app/models/enums/dispute-reason.enum';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';

export interface OrderData {
    Id: string;
    UserName: string;
    OrderType: string;
    StoreName: string;
    DeliveryDateFrom: string;
    OrderDetails: string;
    Status: string;
    OrderAmount: string;
}

declare let window: CustomWindow;

@Component({
    selector: 'partner-orders',
    templateUrl: './partner-orders.component.html',
    styleUrls: ['./partner-orders.component.scss',
    '../../../../../styles/m3-defaul-material-theme.scss'],
    providers: [MessageService]
})
export class PartnerOrdersComponent implements OnInit, AfterViewInit {
    @Input()
    public menuPermissionActive!: string;

    public adminUrl: string = window['adminUrl'];

    public orders: Array<any> = [];

    public cols: any[] = [
        { field: 'Id', header: 'Order ID', width: '90px' },
        { field: 'UserName', header: 'Customer', width: '200px' },
        { field: 'OrderType', header: 'Order type', width: '200px' },
        { field: 'StoreName', header: 'Store', width: '200px' },
        { field: 'DeliveryDateFrom', header: 'Pickup Time', width: '200px' },
        { field: 'OrderDetails', header: 'Items', width: '200px' },
        { field: 'Status', header: 'Status', width: '200px' },
        { field: 'OrderAmount', header: 'Amount', width: '200px' }
    ];

    // Grid settings
    public sortField: string | string[] = 'Id';
    private sortOrder: number = -1;

    displayedColumns: string[] = [
        'Id',
        'UserName',
        'OrderType',
        'StoreName',
        'DeliveryDateFrom',
        'OrderDetails',
        'Status',
        'OrderAmount',
    ];

    dataSource = new MatTableDataSource<OrderData>([]);

    totalRecords = 0;
    pageSize = 10;
    pageIndex = 0;
    pageSizeOptions = [5, 10, 20, 50];
    currentSortDirection: SortDirection = 'desc';

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    public filter: {
        createdAt: Date | undefined;
        orderId: number | undefined;
        locationId: number;
        orderTypeId: number;
        statusId: number;
        search: string;
    } = {
            createdAt: undefined,
            orderId: undefined,
            locationId: 0,
            orderTypeId: 0,
            statusId: 0,
            search: ''
        };

    public locations: Array<any> = [{ Id: 0, Name: 'All' }];

    public orderTypes: Array<any> = [
        { Id: 0, Name: 'All' },
        { Id: OrderDeliveryWayEnum.Delivery, Name: 'Delivery' },
        { Id: OrderDeliveryWayEnum.Pickup, Name: 'Pickup' },
    ];

    public statuses: Array<any> = [
        { Id: 0, Name: 'All' },
        { Id: LokalOrderStatusEnum.New, Name: 'New' },
        { Id: LokalOrderStatusEnum.Packing, Name: 'Preparing' },
        { Id: LokalOrderStatusEnum.ReadyToDispatch, Name: 'Pickup Ready' },
        { Id: LokalOrderStatusEnum.Dispatch, Name: 'Delivering' },
        { Id: LokalOrderStatusEnum.OrderError, Name: 'Order Error' },
        { Id: LokalOrderStatusEnum.Delivered, Name: 'Completed' },
        { Id: LokalOrderStatusEnum.MissingItem, Name: 'Missing Item' },

        { Id: LokalOrderStatusEnum.CancelledByCustomer, Name: 'Cancelled by Customer' },
        { Id: LokalOrderStatusEnum.CancelledByMerchant, Name: 'Cancelled by Merchant' },
        { Id: LokalOrderStatusEnum.CancelledByTimeout, Name: 'Cancelled by Timeout' }

        //{ Id: LokalOrderStatusEnum.Accepted, Name: 'Accepted' }, // not in figma
        //{ Id: LokalOrderStatusEnum.Preparing, Name: 'Preparing' }, // Not used ?
        //{ Id: LokalOrderStatusEnum.Scheduled, Name: 'Scheduled' }, // Not used
    ];

    public showFilterSidebar: boolean = false;

    public editOrderId: number = 0;
    public showOrderDetailsPopup: boolean = false;
    public isFilterApplied: boolean = false;

    public isSpinnerVisible: boolean = false;
    private searchTimer: number = 0;

    products: Array<any> = [];
    showDisputeSidebar: boolean = false;
    discardConfirmDialog: boolean = false;
    disputeReasonId: number = 0;
    disputeDescription: string = '';
    attachedFiles: Array<{name: string; file: File; data: string}> = [];
    otherReason: string = '';
    formattedDate: string = '';
    submitDisputeConfirmDialog: boolean = false;

    profile: { FirstName: string; LastName: string; ImageUrl: string } = { FirstName: '', LastName: '', ImageUrl: '' };

    disputeReasons: ComboItemDto[] = [
        { Id: DisputeReasonEnum.All, Name: 'All' },
        { Id: DisputeReasonEnum.MissingItem, Name: 'Customer complaint - missing item,\nbut it is complete' },
        { Id: DisputeReasonEnum.WrongItem, Name: 'Customer complaint - wrong item,\nbut it is correct' },
        { Id: DisputeReasonEnum.LatePickup, Name: 'Customer complaint - late pickup,\nbut order was ready on time' },
        { Id: DisputeReasonEnum.NoFulfilment, Name: 'Order marked complete but wasn\'t fulfilled' },
        { Id: DisputeReasonEnum.Other, Name: 'Other' }
    ];

    @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('dragleave', ['$event']) onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('drop', ['$event']) onFileDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.onFileSelected(event);
    }

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        private partnerOrderService: PartnerOrderService,
        private appData: AppDataService,
        public dialog: MatDialog) {
        this.onOrderDetailsPopupHide = this.onOrderDetailsPopupHide.bind(this);
    }

    ngOnInit() {
        this.profile.FirstName = this.appData.authData.FirstName;
        this.profile.LastName =  ' ' + this.appData.authData.LastName.slice(0, 1) + '.';
        this.profile.ImageUrl = this.appData.authData.ImageUrl;
        this.getPartnerLocations();
        this.getOrders(0);
    }

    ngAfterViewInit(): void {
        this.sort.disableClear = true;
        this.dataSource.sort = this.sort;
    }

    public getOrders(skip: number): void {
        this.isSpinnerVisible = true;

        const dto = {
            TimeZoneOffset: Utils.getTimezoneOffset(),
            CreatedAt: this.filter.createdAt ? moment(this.filter.createdAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            OrderId: this.filter.orderId,
            OrderTypeId: this.filter.orderTypeId,
            LocationId: this.filter.locationId,
            FilterVal: this.filter.search,
            StatusId: this.filter.statusId,
            Skip: skip,
            Take: this.pageSize,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.partnerOrderService.getPartnerOrders(dto, this.messageService)
            .then(data => {
                this.isSpinnerVisible = false;
                if (!data || !data.OrderList) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.totalRecords = data.TotalRecords;
                this.orders = data.OrderList;

                this.orders.forEach(x => {
                    x.DeliveryDateFrom = Utils.utcToFormatedLocalDateStr(x.DeliveryDateFrom, ',');
                    x.DeliveryDateTo = Utils.utcToFormatedLocalDateStr(x.DeliveryDateTo, ',');
                    x.TransactionDate = Utils.utcToFormatedLocalDateStr(x.TransactionDate, ',');
                });

                this.dataSource.data = this.orders;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to load orders',
                });
                this.dataSource.data = [];
                this.totalRecords = 0;
            })
            .finally(() => {
                this.isSpinnerVisible = false;
            });
    }

    onPageChange(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.getOrders(this.pageIndex * this.pageSize);
    }

    onSortChange(event: Sort) {
        this.sortField = event.active;
        this.currentSortDirection = event.direction || 'asc';
        this.sortOrder = this.currentSortDirection === 'asc' ? 1 : -1;
        this.pageIndex = 0;
        this.getOrders(0);
    }

    private getPartnerLocations() {
        this.partnerOrderService.getPartnerLocations(this.messageService)
            .then(data => {
                if (!data || !data.Items) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.locations = this.locations.concat(data.Items);
            })
            .catch(err => {
                throw err;
            });
    }

    public showFilter(): void {
        this.showFilterSidebar = true;
    }

    public hideFilter(): void {
        this.showFilterSidebar = false;
    }

    public onFilterClear(event: any): void {
        if (!event) {
            this.hideFilter();
            this.isFilterApplied = false;
            this.filter.createdAt = undefined;
            this.filter.orderId = undefined;
            this.filter.locationId = 0;
            this.filter.orderTypeId = 0;
            this.filter.statusId = 0;
            this.filter.search = '';
            this.pageIndex = 0;
            this.getOrders(0);
        }
    }

    public onFilterApply(): void {
        this.pageIndex = 0;
        this.getOrders(0);
        this.hideFilter();
        this.isFilterApplied = true;
    }

    public onReloadClick(): void {
        this.getOrders(this.pageIndex * this.pageSize);
    }

    public handleEditOrderClick(order: any): void {
        this.editOrderId = order.Id.substring(3, order.Id.length);
        this.showOrderDetailsPopup = true;
    }

    public onOrderDetailsPopupHide(): void {
        this.showOrderDetailsPopup = false;
    }

    openOrderViewDialog(order: any){
        order.StatusStyle = this.getStatusStyles(order.Status);

        const dialogRef = this.dialog.open(PartnerOrderViewComponent, {
            width: '1150px',
            minWidth: '1150px',
            height: '825px',
            panelClass: 'parent-dialog-panel',
            disableClose: false,
            autoFocus: false,
            data: order
        });

        dialogRef.afterClosed().subscribe(result => {
            if (Array.isArray(result)) {
                this.formatDate();
                this.products = result;
                this.products.forEach(x => x.checked = false);
                this.showDisputeSidebar = true;
            }
        });
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.pageIndex = 0;
            this.getOrders(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public getStatusStyles(status: string): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case 'New':
                backgroundColor = '#8DDCB7';
                textColor = '#0E5D38';
                break;
            case 'Cancelled by Merchant':
                backgroundColor = '#1F1F1F';
                textColor = '#FFF';
                break;
            case 'Cancelled by Customer':
                backgroundColor = '#F5A09A';
                textColor = '#75211B';
                break;
            case 'Cancelled by Timeout':
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            case 'Delivering':
                backgroundColor = '#127C4A';
                textColor = '#F2FBF7';
                break;
            case 'Preparing':
                backgroundColor = '#0A84FF';
                textColor = '#F1F8FF';
                break;
            case 'Pickup Ready':
                backgroundColor = '#FBBF7F';
                textColor = '#A45400';
                break;
            case 'Order Error':
                backgroundColor = '#FFC043';
                textColor = '#554016';
                break;
            case 'Missing Item':
                backgroundColor = '#CD6900';
                textColor = '#FEF7F0';
                break;
            case 'Completed':
                backgroundColor = '#ADD6FF';
                textColor = '#05427F';
                break;

            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    get filtersAppliedCount(): number {
        return [
            this.filter.createdAt,
            this.filter.orderId,
            this.filter.locationId,
            this.filter.orderTypeId,
            this.filter.statusId,
            this.filter.search
        ].filter(Boolean).length;
    }

    formatDate() {
        const date = new Date();

        const weekday = date?.toLocaleString('en-US', { weekday: 'long' });
        const day = date?.toLocaleString('en-US', { day: 'numeric' });
        const month = date?.toLocaleString('en-US', { month: 'long' });
        const time = date?.toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        const formatted = `${weekday}, ${day} ${month} at ${time}`;
        this.formattedDate = formatted ?? '';
    }

    closeDisputeSidebar() {
        this.discardConfirmDialog = true;
    }

    submitDispute() {
        this.submitDisputeConfirmDialog = false;
        this.showDisputeSidebar = false;
    }

    cancelDiscard() {
        this.discardConfirmDialog = false;
    }

    discardConfirm() {
        this.discardConfirmDialog = false;
        this.showDisputeSidebar = false;
    }

    selectProduct(missingProduct: any) {
        missingProduct.checked = !missingProduct.checked;
    }

    cancelSubmitDispute() {
        this.submitDisputeConfirmDialog = false;
    }

    isSubmitDisabled() {
        const anyProductsSelected = this.products.find(x => x.checked);
        const anyFilesAttached = this.attachedFiles.length > 0;
        if (!anyProductsSelected || !this.disputeReasonId || (this.disputeReasonId === DisputeReasonEnum.Other && !this.otherReason) || !anyFilesAttached) {
            return true;
        }

        return false;
    }

    onFileSelected(event: Event | DragEvent): void {
        const target = event.target as HTMLInputElement;
        let files = target?.files;

        const dataTransfer = (event as DragEvent).dataTransfer;
        if (dataTransfer) {
            files = dataTransfer.files;
        }

        if (!files || !files.length) {
            return;
        }

        // Process all selected files
        Array.from(files).forEach(file => {
            if (this.isValidFileType(file)) {
                this.getBlobStringFromFile(file);
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'File type not supported. Accepted types: JPG, PNG, HEIC, HEIF, MP4, MOV, MKV, AVI'
                });
            }
        });
    }

    private isValidFileType(file: File): boolean {
        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/png', 'image/heic', 'image/heif',
            'video/mp4', 'video/quicktime', 'video/x-matroska', 'video/x-msvideo'
        ];
        const allowedExtensions = ['.jpg', '.jpeg', '.png', '.heic', '.heif', '.mp4', '.mov', '.mkv', '.avi'];
        const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
        return allowedTypes.includes(file.type.toLowerCase()) || allowedExtensions.includes(fileExtension);
    }

    private getBlobStringFromFile(file: File): void {
        // Check file size limits based on file type
        const isImage = file.type.startsWith('image/') || ['.jpg', '.jpeg', '.png', '.heic', '.heif'].includes('.' + file.name.split('.').pop()?.toLowerCase());
        const isVideo = file.type.startsWith('video/') || ['.mp4', '.mov', '.mkv', '.avi'].includes('.' + file.name.split('.').pop()?.toLowerCase());
        const maxImageSize = 5 * 1024 * 1024; // 5MB
        const maxVideoSize = 10 * 1024 * 1024; // 10MB
        if (isImage && file.size > maxImageSize) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Image file is too large. Maximum size is 5MB.' });
            return;
        }
        if (isVideo && file.size > maxVideoSize) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Video file is too large. Maximum size is 10MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (progressEvent: ProgressEvent<FileReader>) => {
            if (progressEvent?.target?.result) {
                this.attachedFiles.push({
                    name: file.name,
                    file,
                    data: progressEvent.target.result.toString()
                });
            }
        };

        reader.onerror = (error) => {
            console.error('Error reading file:', error);
        };

        reader.readAsDataURL(file);
    }

    removeAttachedFile(index: number): void {
        this.attachedFiles.splice(index, 1);
    }

    protected readonly Utils = Utils;
    protected readonly Date = Date;
    protected readonly DisputeReasonEnum = DisputeReasonEnum;
}
